<ng-container *ngIf="forCarousel">
  <div class="insights-carousel" >
    <!-- Rank START -->

    <ngx-slick-carousel
      [ngClass]="{'limit-width':numberOfItems.length <=2}"
      *ngIf="slideConfig"
      #carousel
      class="carousel"
      [config]="slideConfig"
      #slickModal="slick-carousel"
    >
      <ng-container *ngFor="let ranking_insight of getRankingInsightItems()">
        <a [routerLink]="['./../statistics']" [queryParamsHandling]="'merge'">
          <app-athlete-insights ngxSlickItem>
            <h2 class="insight insight__middle">{{'WorldRanking' | transloco}}</h2>
            <h2 class="insight insight__header">{{ ranking_insight.Rnk }}</h2>
            <p class="insight insight__down category">{{ ranking_insight.CatName }}</p>
          </app-athlete-insights>
        </a>
      </ng-container>
<!-- Rank END-->

      <!-- OLYMPIC/PARALYMPIC CHAMPION STARTS-->
      <ng-container *ngFor="let medal of model.olympic_champion">
        <a
          [routerLink]="['./../results']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ search: 'Olympic' }"
        >
          <app-athlete-insights ngxSlickItem>
            <img
              src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=Olympic champion.svg"
              class="insight insight__header"
            />
            <h2 class="insight insight__middle">
              {{ "olympic_champion" | transloco }}
            </h2>
          </app-athlete-insights>
        </a>
      </ng-container>
      <ng-container *ngFor="let medal of model.olympic_medallist">
        <a
        [routerLink]="['./../results']"
        [queryParamsHandling]="'merge'"
        [queryParams]="{ search: 'Olympic' }"
      >
        <app-athlete-insights ngxSlickItem>
          <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/olympic-medallist-{{
              medal.Medals.Golds > 0 ? 'gold' : medal.Medals.Silvers > 0 ? 'silver' : 'bronze'
            }}.svg"
            class="insight insight__header"
          />
          <h2 class="insight insight__middle">
            {{ "olympic_medallist" | transloco }}
          </h2>
        </app-athlete-insights>
        </a>
      </ng-container>
      <ng-container *ngFor="let medal of model.paralympic_champion">
        <a
          [routerLink]="['./../results']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ search: 'Paralympic' }"
        >
          <app-athlete-insights ngxSlickItem>
            <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=paraympic champion.svg"
            class="insight insight__header"
            />
            <h2 class="insight insight__middle">
              {{ "paralympic_champion" | transloco }}
            </h2>
          </app-athlete-insights>
        </a>
      </ng-container>
      <ng-container *ngFor="let medal of model.paralympic_medallist">
        <a
        [routerLink]="['./../results']"
        [queryParamsHandling]="'merge'"
        [queryParams]="{ search: 'Paralympic' }"
      >
        <app-athlete-insights ngxSlickItem>
          <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/paralympic-medallist-{{
              medal.Medals.Golds > 0 ? 'gold' : medal.Medals.Silvers > 0 ? 'silver' : 'bronze'
            }}.svg"
            class="insight insight__header"
          />
          <h2 class="insight insight__middle">
            {{ "paralympic_medallist" | transloco }}
          </h2>
        </app-athlete-insights>
        </a>
      </ng-container>
      <!-- OLYMPIC/PARALYMPIC CHAMPION ENDS-->

      <!-- CHAMPIONSHIPS START -->
      <ng-container *ngFor="let medal of model.world_archery_champion">
        <a
          [routerLink]="['./../results']"
          [queryParamsHandling]="'merge'"
          [queryParams]="{ search:  medal.ComSubLevelDescr }"
        >
          <app-athlete-insights ngxSlickItem>
            <img
              src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/world champion.svg"
              class="insight insight__header"
            />
            <h2 class="insight insight__middle">
              {{getChampionCategoryName(medal.ComSubLevel.toString())}}
            </h2>
          </app-athlete-insights>
        </a>
      </ng-container>
      <!-- CHAMPIONSHIPS END -->

      <ng-container *ngFor="let medal of model.world_medallist">
        <a
        [routerLink]="['./../results']"
        [queryParamsHandling]="'merge'"
        [queryParams]="{ search: medal.ComSubLevelDescr }"
        >
        <app-athlete-insights ngxSlickItem>
          <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/world-medallist-{{
              medal.Rnk === 1 ? 'gold' : medal.Rnk === 2 ? 'silver' : 'bronze'
            }}.svg"
            class="insight insight__header"
          />
          <h2 class="insight insight__middle">{{ 'world_medallist' | transloco }}</h2>
        </app-athlete-insights>
      </a>
      </ng-container>
    <ng-container *ngIf="model.world_cup_champion as wCupChampion">
      <a
      [routerLink]="['./../results']"
      [queryParamsHandling]="'merge'"
      [queryParams]="{ search: 'World Cup final' }"
      >
      <app-athlete-insights ngxSlickItem>
        <img
          style="margin-bottom: -18px;"
          src="../../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=world cup champion-1.svg"
          class="insight insight__header"
        />
        <div style="margin-top:23px" class="insight insight__middle count">
          <h2 class="count">{{wCupChampion.count}}<div class="deco">x</div></h2><h2 class="insight insight__middle no-max-width">{{ 'world_cup_champion' | transloco }}</h2></div>
      </app-athlete-insights>
    </a>
       </ng-container>
  <!-- OLYMPIC / PARALYMPIC START -->
  <ng-container *ngFor="let olympian of model.olympian">
    <a
    [routerLink]="['./../results']"
    [queryParamsHandling]="'merge'"
    [queryParams]="{ search: 'Olympic' }"
  >
    <app-athlete-insights ngxSlickItem>
      <img
        src="../../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=olympic games.svg"
        class="insight insight__header"
      />
      <h2 class="insight insight__middle">{{ "olympian" | transloco }}</h2>
    </app-athlete-insights>
    </a>
  </ng-container>
  <ng-container *ngFor="let paralympic of model.paralympic">
    <a
    [routerLink]="['./../results']"
    [queryParamsHandling]="'merge'"
    [queryParams]="{ search: 'Paralympic' }"
  >
    <app-athlete-insights ngxSlickItem>
      <img
        src="../../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=paraympic games.svg"
        class="insight insight__header"
      />         <h2 class="insight insight__middle">{{ "paralympic" | transloco }}</h2>
    </app-athlete-insights>
    </a>
  </ng-container>
    <!-- OLYMPIC / PARALYMPIC END -->



      <!-- RECORDS START -->
      <ng-container *ngFor="let record of model.world_record_holder">
        <a [routerLink]="['./../records']" [queryParamsHandling]="'merge'">

        <app-athlete-insights ngxSlickItem>
          <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=world record holder.svg"
            class="insight insight__header"
          />
          <h2 class="insight insight__middle">
            {{ "world_record_holder" | transloco }}
          </h2>
        </app-athlete-insights>
      </a>
      </ng-container>
    <ng-container *ngFor="let record of model.paralympic_record_holder">
      <a [routerLink]="['./../records']" [queryParamsHandling]="'merge'">
        <app-athlete-insights ngxSlickItem>
          <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=paralympic record holder.svg"
            class="insight insight__header"
          />
          <h2 class="insight insight__middle">
            {{ "paralympic_record_holder" | transloco }}
          </h2>
        </app-athlete-insights>
      </a>
    </ng-container>
    <ng-container *ngFor="let record of model.olympic_record_holder">
      <a [routerLink]="['./../records']" [queryParamsHandling]="'merge'">
        <app-athlete-insights ngxSlickItem>
          <img
            src="../../../../modules/custom/wa_angular/app/assets/icons/insights_icons/name=Olympic record holder.svg"
            class="insight insight__header"
          />
          <h2 class="insight insight__middle">
            {{ "olympic_record_holder" | transloco }}
          </h2>
        </app-athlete-insights>
      </a>
    </ng-container>
    <!-- RECORDS END -->
       <ng-container *ngFor="let match of model.match_wins">
        <a [routerLink]="['./../statistics']" [queryParamsHandling]="'merge'">
          <app-athlete-insights ngxSlickItem>
            <h2 class="insight insight__header">
              {{ match.MatchWinPercentage.toFixed(0) }} %
            </h2>
            <h2 class="insight insight__middle">
              {{ "match_percent_win" | transloco }}
            </h2>
            <p class="insight insight__down info">
              ({{ match.MatchTot }} {{ "matches" | transloco }})
            </p>
          </app-athlete-insights>
        </a>
      </ng-container>
      <!-- STATS END-->
      <ng-container *ngFor="let compound of model.competition_best_compound">
        <a [routerLink]="['./../statistics']" [queryParamsHandling]="'merge'">
          <app-athlete-insights ngxSlickItem>
            <h2 class="insight insight__header">
              {{ compound.QBest.toFixed(0) }}
            </h2>
            <h2 class="insight insight__middle">
              {{ "competition_best" | transloco }}
            </h2>
            <p class="insight insight__down category">
              {{ "compound" | transloco }}
              {{ (model.data[0].Gender === "M" ? "men" : "women") | transloco }}
            </p>
          </app-athlete-insights>
        </a>
      </ng-container>

      <ng-container *ngFor="let recurve of model.competition_best_recurve">
        <a [routerLink]="['./../statistics']" [queryParamsHandling]="'merge'">
          <app-athlete-insights ngxSlickItem>
            <h2 class="insight insight__header">
              {{ recurve.QBest.toFixed(0) }}
            </h2>
            <h2 class="insight insight__middle">
              {{ "competition_best" | transloco }}
            </h2>
            <p class="insight insight__down category">
              {{ "recurve" | transloco }}
              {{ (model.data[0].Gender === "M" ? "men" : "women") | transloco }}
            </p>
          </app-athlete-insights>
        </a>
      </ng-container>
      <!-- STATS END -->
    </ngx-slick-carousel>
  </div>
</ng-container>
